import React, { } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

interface inputProps {
    /** @param {Array<any>} data data of your radio group*/
    data: Array<any>,
    /** @param {any}  value value which want to bind in the label*/
    value: any,
    /** @param {string} displayName name which want to display in the label*/
    displayName: string,
    /** @param {"horizontol" | "vertical"} direction direction of radio group*/
    direction: "horizontol" | "vertical",
    /** @param {any} defaultValue pass the value then only default check is work*/
    defaultValue?: any,
    /** @param {string} className to define your css here*/
    className?: string,
    onChange?: any,
    disable?: any,
    id?: any
}

export const CustomRadioGroup = React.forwardRef(({ data, value, defaultValue, direction, displayName, className, onChange, disable, id }: inputProps, ref) => {
    return (
        <FormGroup className={className} style={{ display: direction == "horizontol" ? "flex" : "unset" }} id={id} >
            {data.map((x, i) => (
                <FormGroup check style={{ marginRight: "10px" }} key={i} id={id} >
                    <Label check>
                        <Input disabled={x.disable} defaultChecked={(defaultValue == x[value])} value={x[value] ? x[value] : x} onChange={onChange} type="radio" name={`${value}_name`} id={id} />
                        <p>
                            {x[displayName] ? x[displayName] : x}
                        </p>
                    </Label>
                </FormGroup>
            ))}
        </FormGroup>
    )
})